










import Vue from 'vue';
import TimeItem from './TimeItem.vue';

export default Vue.extend({
  components: { TimeItem },
});
